import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
} from "antd";
import React, { useState } from "react";

function EmergencyContact({ data }) {
  const [checked, setChecked] = useState(false);
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Emergency Contact"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                  labelWrap={{ span: 8 }}
                >
                  <Form.Item label="Name">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Address">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Phone Number">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Email Address">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Relationship">
                    <Input />
                  </Form.Item>
                </Form>
              </Col>
              <Col span={24}>
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary">Save</Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
            >
             <Form.Item label="Name">
                    <p>--</p>
                  </Form.Item>
                  <Form.Item label="Address">
                    <p>--</p>
                  </Form.Item>
                  <Form.Item label="Phone Number">
                    <p>--</p>
                  </Form.Item>
                  <Form.Item label="Email Address">
                    <p>--</p>
                  </Form.Item>
                  <Form.Item label="Relationship">
                    <p>--</p>
                  </Form.Item>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default EmergencyContact;
